import { getUserStatusDetails } from '../Services/user';
import { setAllUSersStatus } from '../Store/reducers/users';
import { store } from "../Store";
const getUserDetailsAction = async (data) => {
  try {
    const result = await getUserStatusDetails(data);
    store.dispatch(setAllUSersStatus(result.data));
    return result;
  } catch (err) {
    return err;
  }
};
export { getUserDetailsAction };
